import React from 'react';
import { APP_DEFAULT_STATE, AUTH_DEFAULT_STATE } from 'constants/index';

export const UserContext = React.createContext(APP_DEFAULT_STATE);
export const AuthContext = React.createContext(AUTH_DEFAULT_STATE);
